var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89722 9.0065L13.9228 0.953047C14.1122 0.762995 14.3371 0.667969 14.5975 0.667969C14.8579 0.667969 15.0828 0.762995 15.2722 0.953047C15.4616 1.1431 15.5563 1.36879 15.5563 1.63011C15.5563 1.89143 15.4616 2.11711 15.2722 2.30717L6.5601 11.0496C6.37071 11.2396 6.14975 11.3346 5.89722 11.3346C5.6447 11.3346 5.42374 11.2396 5.23434 11.0496L1.16238 6.96344C0.972982 6.77339 0.882231 6.5477 0.890122 6.28638C0.898013 6.02506 0.996656 5.79937 1.18605 5.60932C1.37544 5.41927 1.60035 5.32424 1.86077 5.32424C2.12118 5.32424 2.34609 5.41927 2.53548 5.60932L5.89722 9.0065Z",
    fill: "#02B583"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.f1739a23ed06b33b654d2649a7d7eb26.svg";
export { ForwardRef as ReactComponent };